export enum TipologiaGruppiQuestionari {
    tipologia1 = 'TIPOLOGIA1',
    tipologia2 = 'TIPOLOGIA2'
}